import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'

export const emailField = z
  .email(m('email.invalid'))
  .nonempty(m('email.required'))
  .max(100)
